import {
  each,
  filter,
  remove
} from 'lodash';
import app from '../../angular_app.es6';
import remoteFiles from '../../../approach-react/common/remote_files';
import { addAttributeMethodsToScope } from './helpers/attributes_helper.es6';
import { customMetricsChanged } from './helpers/custom_metrics_helper.es6';

app.controller('DetailsFlavorController', [ '$scope', 'Notification', '$timeout', '$http', '$element', '$interval', '$rootScope',
  ($scope, Notification, $timeout, $http, $element, $interval, $rootScope) => {
    $scope.form = {};
    $scope.source_form = {};
    $scope.options = {};
    $scope.checkInterval = 5000;
    $scope.checkEvery5s = null;

    $scope.state = {
      brandError: false,
      gridError: false
    };

    $scope.init = (data, options, notification, errors) => {
      data.buzzback = options.buzzback;
      $scope.form = angular.copy(data);
      $scope.source_form = data;
      $scope.options = options;
      $scope.notification = notification;
      $scope.asyncGenerateJID = $scope.options.jid;

      if ($scope.asyncGenerateJID) {
        $scope.checkEvery5s = $interval($scope.checkAsyncGenerate, $scope.checkInterval);
        $rootScope.$broadcast('disableNavButtons');
      }

      $scope.errors = errors;
      if ($scope.errors && $scope.errors['express_metrics.brand_name']) {
        $scope.state.brandError = true;
      }
      if ($scope.errors && $scope.errors['express_metrics.grid_items.question']) {
        $scope.state.gridError = true;
      }

      if ($scope.notification) {
        Notification.error($scope.notification);
      }
      $scope.images = remoteFiles.express.steps.flavor.tooltips;
      addAttributeMethodsToScope($scope);
    };

    $scope.actualGridItems = (metric) => (filter(metric.grid_items, (item) => !item._destroy));

    $scope.isGrid = (metric) => (metric.metric_kind === "grid");

    $scope.isSingle = (metric) => (metric.metric_kind === "single");

    $scope.canAddItem = (metric) => {
      const editableCnt = filter(
        $scope.actualGridItems(metric),
        (item) => item.editable
      ).length;
      const selectedCnt = filter(
        $scope.actualGridItems(metric),
        (item) => (!item.editable && item.enabled)
      ).length;

      return (editableCnt + selectedCnt) < $scope.options.max_items;
    };

    $scope.canAddN = (metric) => {
      const selectedCnt = filter(
        $scope.actualGridItems(metric),
        (item) => (!item.editable && item.enabled)
      ).length;

      return $scope.options.max_items - selectedCnt;
    };

    $scope.deleteItem = (event, metric, item) => {
      event.preventDefault();
      if (!item.id) {
        remove(metric.grid_items, item);
      } else {
        item._destroy = true;
      }
    };

    $scope.disableSingleMetrics = (el) => (
      el.metric_kind === "single" &&
      el.default_metric_title.toLowerCase() === "purchase interest" &&
      $scope.form.concepts_mode === "sequential_turf"
    );

    $scope.$watch('form.concepts_num', (newVal) => {
      if (!newVal) {
        return;
      }

      each(
        $scope.options.diagnostics_options,
        (el) => { el.enabled = (el.value <= $scope.form.concepts_num); }
      );
      if ($scope.form.concepts_num < $scope.form.diagnostics_num) {
        $scope.form.diagnostics_num = $scope.form.concepts_num;
      }
    });

    $scope.$watch('form.preference_enabled', (newVal) => {
      if (typeof newVal == "boolean" && !newVal) {
        $scope.form.preference_reasons = false;
      }
    });

    // private

    $scope.checkAsyncGenerate = () => {
      $http.get($scope.options.check_status_url).then(
        (success) => {
          if (success.data.status === "finished") {
            $interval.cancel($scope.checkEvery5s);
            $scope.asyncGenerateJID = null;
            window.location.href = $scope.options.next_step_url;
          } else if (success.data.status === "failed") {
            $scope.asyncGenerateJID = null;
            $interval.cancel($scope.checkEvery5s);
            Notification.error("Project rebuilding failed.");
            $rootScope.$broadcast('enableNavButtons');
          }
        },
        (reject) => {
          $interval.cancel($scope.checkEvery5s);
          $scope.asyncGenerateJID = null;
          console.log('checkAsyncGenerate', reject);
          $rootScope.$broadcast('enableNavButtons');
        }
      );
    };

    $scope.$on('project-form-next-step', (event) => {
      each(
        filter($scope.form.express_metrics, (item) => $scope.isGrid(item)),
        (metric) => {
          const enabledItemsCount = filter(
            $scope.actualGridItems(metric),
            (item) => item.enabled
          ).length;

          if (!enabledItemsCount) {
            metric.enabled = false;
          }
        });

      if ($scope.asyncGenerateJID) {
        event.preventDefault();
        Notification.error("Rebuilding in progress.");
        return;
      }

      const changesPresent = trackChanges() || customMetricsChanged();
      const form = $('#details_form');

      if (!$scope.options.need_generate || !$scope.options.is_valid) {
        form.submit();
      } else if (!changesPresent && !$scope.notification) {
        event.preventDefault();
        window.location.href = $scope.options.next_step_url;
      } else if (confirm($scope.options.change_structure_message)) {
        form.submit();
      }
    });

    const trackChanges = () => (!angular.equals($scope.form, $scope.source_form));
  } ]);
